import { DocumentCaptureError } from './DocumentCaptureError';

class UploadDocumentError extends DocumentCaptureError {
  constructor(message: string, title: string = 'Document Upload Error') {
    super(message);
    this.name = 'UploadDocumentError';
    this.title = title;

    // This line is needed to fix the stack trace (which is off by default)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, UploadDocumentError);
    }
  }

  public static getErrorMessage(e: unknown) {
    // specific upload document error handling
    // tried to find some mapping of an expected error to return
    // but couldn't find any then we need to use
    // default error handling
    return super.getErrorMessage(e);
  }
}

export { UploadDocumentError };
